import React from 'react';
import { IMessageInput } from './interfaces';
import { Avatar, Box, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '@routes/routes';

export const MessageInput: React.FC<IMessageInput> = ({
  author,
  placeholder,
  value,
  onChange,
  onEnter,
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'start',
        gap: '10px',
      }}
    >
      <Avatar
        src={ROUTES.images.avatar(author.slug)}
        alt={author.name}
        sx={{
          width: '35px',
          height: '35px',
        }}
      />
      <TextField
        fullWidth
        multiline
        placeholder={placeholder || t('feed:fields.postMessage.placeholder')}
        value={value}
        onChange={(event) => {
          onChange(event.target.value);
        }}
        onKeyDown={(event) => {
          if (onEnter && event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            onEnter();
          }
        }}
        InputProps={{
          sx: {
            '&.MuiInputBase-root': {
              padding: '10px',
            },
            fontSize: '.85rem',
          },
        }}
      />
    </Box>
  );
};
